module.exports = __webpack_public_path__ + "media/images/vp/icon.city.red-d322cf2f75323e8de490fb383c81ee5b.svg";